import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M2.929 4.929c3.905-3.906 10.237-3.906 14.142 0a1 1 0 1 1-1.414 1.414 8 8 0 1 0 0 11.314 1 1 0 0 1 1.414 1.414c-3.905 3.905-10.237 3.905-14.142 0-3.905-3.905-3.905-10.237 0-14.142Zm16.407 3.324a1 1 0 0 1 1.411.083l2.667 3a1 1 0 0 1 0 1.328l-2.667 3a1 1 0 0 1-1.494-1.328L20.44 13H10a1 1 0 1 1 0-2h10.44l-1.187-1.336a1 1 0 0 1 .083-1.411Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
